import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Action from './components/Action';
import App from './components/App';
import Home from './components/Home';
import Landing from './components/Landing';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Home />} />
        <Route path="/action" element={<Action />} />
      </Routes>
    </App>
  </BrowserRouter>
);
